export async function apiRequest(apiFn, ...args) {
  try {
    return await apiFn(...args)
  } catch (error) {
    if (error.redirect_uri) {
      window.location.href = error.redirect_uri
      return
    }
    throw error
  }
}
